import Vue from 'vue'
import axios from 'axios'
import { Notification } from '@jdcloud/jelement-next'
import { isNull } from '@/utils'
import Cookies from 'js-cookie'
// import {LINK} from ''
const service = axios.create({
  timeout: 20000,
  withCredentials: true,
})
// loading 组
let ARR_LOADING = []
let IS_LOADING = false
let LOADING_INSTANCE = null

service.interceptors.request.use((config) => {
  if (config.isLoading) {
    ARR_LOADING.push(config.url)
    if (!IS_LOADING) {
      IS_LOADING = true
      let loadingConfig = {
        // text: '努力加载中...'
      }
      if (config.target) {
        loadingConfig.target = config.target
      }
      LOADING_INSTANCE = Vue.$loading(loadingConfig)
    }
  }
  if (config.isCsrf && Cookies.get('csrfToken')) {
    Object.assign(config.headers, {
      'x-csrf-token': Cookies.get('csrfToken'),
    })
  }
  return config
})
service.interceptors.response.use(
  (response) => {
    let {
      data: { code, success, message, data },
      config,
    } = response
    if (config.isLoading) {
      let index = ARR_LOADING.indexOf(config.url)
      ARR_LOADING.splice(index, 1)
      if (ARR_LOADING.length === 0) {
        LOADING_INSTANCE && LOADING_INSTANCE.close()
        LOADING_INSTANCE = null
        IS_LOADING = false
      }
    }
    // 如果不是code 返回值
    if (isNull(code) && isNull(success)) {
      return response.data
    }
    if (code !== 0 || success === false) {
      // 是否自动提示消息
      if (config.isOutMsg) {
        Notification({
          type: 'error',
          message: message || '出错啦，请确认网络是否正常，稍后再试',
        })
      }
      return Promise.reject({code, data, message}) // eslint-disable-line
    } else {
      return response.data
    }
  },
  (error) => {
    ARR_LOADING = []
    if (LOADING_INSTANCE) {
      LOADING_INSTANCE.close()
      LOADING_INSTANCE = null
    }
    IS_LOADING = false
    const {
      response: { status, data, config },
    } = error
    console.error(error)
    // 未登录跳转，接入角色
    if (error.response && error.response.status === 401) {
      if (error.response.data && error.response.data.loginUrl) {
        window.location.href = `${decodeURIComponent(
          error.response.data.loginUrl,
        )}?returnUrl=${encodeURIComponent(window.location.href)}`
      }
      return Promise.reject(error)
    }
    if (status === 402) {
      window.location.href =
        derivativeConfig.active + encodeURIComponent(window.location.href)
      return
    }
    if (status === 403) {
      Notification.error({
        title: '您没有权限执行此操作，请联系管理员为您添加权限。',
        message: '',
        duration: 10000,
      })
      return
    }
    if (config.isOutMsg) {
      Notification({
        type: 'error',
        message: data ? data.message : '出错啦，请确认网络是否正常，稍后再试',
      })
      return Promise.reject(error)
    } else {
      let returnError = data.error || error
      return Promise.reject(returnError) // eslint-disable-line
    }
  },
)
export default service
